import { Component, ElementRef } from '@angular/core';
import { ConfirmContactComponent } from '@components/confirm-contact/confirm-contact.component';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';

import { BasePersistentNotification } from '../base-persistent-notification';

@Component({
  selector: 'vnm-contact-notification',
  styleUrls: ['./contact-notification.component.scss'],
  templateUrl: './contact-notification.component.html'
})
export class ContactNotificationComponent extends BasePersistentNotification {
  constructor(private dialogService: DialogService, private translateService: TranslateService, el: ElementRef) {
    super(el);
  }

  presentConfirmation() {
    this.dialogService.open(ConfirmContactComponent, {
      header: this.translateService.instant('confirm-contact.dialog-title'),
      dismissableMask: false,
      data: { method: { ...this.record } }
    });
  }
}
